<template>
    <div class="notif">
        <v-loading :loading="loading"></v-loading>
        <div class="notif__header flex flex--justify-between flex--align-center">
            <div class="notif__header__title">消息推送管理</div>
            <Button class="notif__header__btn" shape="circle" type="primary">
                <v-icon type="iconadd-24px" right-text="新消息" @click.native="handleCreateNewNotif"></v-icon>
            </Button>
        </div>
        <div class="notif__filter flex" :shadow="scrollTop > 30">
            <div class="notif__filter__item" style="width: 162px; margin-right: 16px">
                <span class="label">消息类型:</span>
                <Select :value="searchParams.type"
                        placeholder="消息类型"
                        @on-change="val => handleFilter(val, 'type')"
                        transfer>
                    <Option value="all">不限</Option>
                    <Option :value="item.key"
                            :key="item.key"
                            v-for="item in [{key: 'MARKETING', value: '营销需求'}, {key: 'MAINTENANCE', value: '系统维护'}]">{{item.value}}</Option>
                </Select>
            </div>
            <div class="notif__filter__item" style="width: 162px; margin-right: 16px">
                <span class="label">消息状态:</span>
                <Select :value="searchParams.status"
                        placeholder="消息状态"
                        @on-change="val => handleFilter(val, 'status')"
                        transfer>
                <Option value="all">{{'不限'}}</Option>
                <Option :value="item.key"
                        :key="item.key"
                        v-for="item in [{key: 'PENDING', value: '待发送'}, {key: 'SENT', value: '已发送'}]">{{item.value}}</Option>
                </Select>
            </div>
            <div class="notif__filter__item" style="flex-grow: 1">
                <Input prefix="ios-search"
                    :value="searchParams.term"
                    @on-change="handleFilter($event.target.value, 'term')"
                    placeholder="信息标题、消息内容"/>
            </div>
        </div>
        <div class="notif__body" @scroll="handleScroll">
            <div class="notif__section" v-for="tn in timelineNotifs" :key="tn.timestr">
                <div class="notif__section__title">{{ tn.timestr }}</div>
                <notif-card v-for="notif in tn.notifs"
                    :key="notif.id"
                    :ndata="notif"
                    :disabled="notif.status === 'SENT'"
                ></notif-card>
            </div>
            <div class="notif__section" v-if="sentNotifs.length > 0">
                <div class="notif__section__title">已完成</div>
                <notif-card v-for="notif in sentNotifs"
                    :key="notif.id"
                    :ndata="notif"
                    disabled
                ></notif-card>
            </div>
        </div>
        <new-notif-card></new-notif-card>
        <delete-confirm></delete-confirm>
    </div>
</template>
<script>
import NotifCard from "./notifCard.vue";
import NewNotifCard from "./newNotifCard.vue";
import DeleteConfirm from "./deleteConfirm.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
    components: {
        NotifCard,
        NewNotifCard,
        DeleteConfirm
    },
    data() {
        return {
            scrollTop: 0,
        }
    },
    computed: {
        ...mapState("notification", ["notifications", "loading", "searchParams"]),
        sentNotifs() {
            if (this.notifications && this.notifications.length > 0)
                return this.notifications.filter(n => n.timestamp < moment().startOf('day'));
            else
                return [];
        },
        timelineNotifs() {
            const notifs = this.notifications.filter(n => n.timestamp >= moment().startOf('day'));
            const arr = [];
            notifs.forEach(n => {
                let dateStr = moment(n.timestamp).startOf('day').format('YYYY-MM-DD');
                if (dateStr === moment().startOf('day').format('YYYY-MM-DD'))
                    dateStr = '今天';
                else if (dateStr === moment().add(1, 'day').startOf('day').format('YYYY-MM-DD'))
                    dateStr = '明天';
                if (arr.length > 0 && arr[arr.length - 1].timestr === dateStr)
                    arr[arr.length - 1].notifs.push(n);
                else
                    arr.push({
                        timestr: dateStr,
                        notifs: [n]
                    });
            });
            if (arr.length > 0 && arr[0].timestr === '今天') {
                const sent = arr[0].notifs.filter(n => n.status === 'SENT').sort((a, b) => b.timestamp - a.timestamp);
                const unsent = arr[0].notifs.filter(n => n.status === 'PENDING').sort((a, b) => a.timestamp - b.timestamp);
                arr[0].notifs = unsent.concat(sent);
            }
            return arr;
        }
    },
    methods: {
        ...mapActions({
            resetStore: "notification/reset",
            getNotifs: "notification/getNotifs",
            setToCreate: "notification/setToCreate",
            updateSearchParams: "notification/updateSearchParams",
        }),
        handleFilter(val, name) {
            if (val || name === 'term') {
                this.updateSearchParams({
                    name,
                    val
                });
                // this.searchParams[name] = val;
            }
            // this.getNotifs();
        },
        handleCreateNewNotif() {
            this.setToCreate();
        },
        handleScroll(e) {
            const { scrollTop, clientHeight, scrollHeight } = e.target;
            this.scrollTop = scrollTop;
            if (scrollTop + clientHeight >= scrollHeight - 50) {
                this.getNotifs();
            }
            // if (this.pageNum * this.pageSize < this.total) {
            //     const { scrollTop, clientHeight, scrollHeight } = e.target;
            
            // }
        },
    },
    created() {
        this.resetStore();
        this.getNotifs();
    },
}
</script>
<style lang="less">
    .notif {
        height: 100%;
        overflow: hidden;
        position: relative;
        &__header {
            padding: 16px 16px 28px 16px;
            width: 784px;

            &__title {
                font-size: 21px;
                font-weight: 500;
                line-height: 32px;
                color: rgba(black, 0.54);
            }

            &__btn {
                height: 36px;
            }
        }

        &__filter {
            width: 784px;
            height: 36px;
            padding: 0 16px;
            margin-bottom: 22px;

            // &[shadow] {
            //     box-shadow: 0 24px 38px 3px rgba(0,0,0,0.10), 0 9px 46px 8px rgba(0,0,0,0.08), 0 11px 15px 0 rgba(0,0,0,0.16);
            // }

            &__item {
                position: relative;
            }
            .label{
                color: rgba(0, 0, 0, 0.87);
                position: absolute;
                left: 16px;
                line-height: 32px;
                font-size: 14px;
                font-weight: 500;
                z-index: 1;
            }
            .ivu-input{
                border-radius: 8px;
                color: rgba(0, 0, 0, 0.87);
                font-size: 14px;
                line-height: 32px;
                font-weight: 500;
                border-color: rgba(0, 0, 0, 0.08);
            }
            .ivu-select{
                // height: 36px !important;
                color: rgba(0, 0, 0, 0.87);
                font-weight: 500;
                position: relative;
                z-index: 2;
            }
            .ivu-select-selection{
                border-radius: 8px;
                border-color: rgba(0, 0, 0, 0.08);
                padding-left: 70px;
                box-shadow: none;
                background-color: transparent;
            }
        }

        &__body {
            padding: 0 16px;
            height: calc(100% - 138px);
            overflow-y: scroll;
        }

        &__section {
            margin-bottom: 40px;
            &__title {
                font-size: 21px;
                font-weight: 500;
                line-height: 24px;
                color: rgba(black, 0.54);
            }
        }
    }
</style>